import type { ISubscription } from './subscription';

export interface IUserProfile {
    age?: number;
    assets?: number;
    businessYears?: number;
    city: string;
    college?: string;
    created: string;
    disabled?: boolean;
    email: string;
    firmName?: string;
    firmSize?: number;
    firstName: string;
    gender?: string;
    lastName: string;
    phone?: number;
    role: string;
    state: string;
    zip: string;
    uid: string;
    updated: string;
    username?: string;
    showDnc: boolean;
    subscription: ISubscription;
    brokerageLicenseNumber?: string;
    brokerageName?: string;
}

export interface IUser {
    accessToken: string;
    accessTokenExpiresAt: string;
    refreshToken: string;
    refreshTokenExpiresAt: string;
    user: IUserProfile;
}

export interface IUserSignInData {
    email: string;
    password: string;
}

export interface IUserSignUpData {
    firstName: string;
    lastName: string;
    zip: string;
    state?: string;
    email: string;
    age?: number;
    gender?: string;
    brokerageLicenseNumber?: string;
    brokerageName?: string;
    averageHomeValue?: AverageHomeValue;
    housesSold?: HousesSold;
    yearsExperience?: YearsExperience;
    phone?: string;
}

export enum CheckEmailStatus {
    NEW_SIGNUP = 'NEW_SIGNUP',
    CONTRACT_ALREADY_SIGNED = 'CONTRACT_ALREADY_SIGNED',
    E_CONFLICT_USER_EXISTS = 'E_CONFLICT_USER_EXISTS',
}

export enum HousesSold {
    '0 - 5',
    '5 - 10',
    '10 – 15',
    '15 – 20',
    '20 – 25',
    '25 – 50',
    '50+',
}

export enum AverageHomeValue {
    '100K – 300K',
    '300K – 500K',
    '500K – 1MM',
    '1MM – 3MM',
    '3MM +',
}

export enum YearsExperience {
    '< 1',
    '1-5',
    '5-10',
    '10 +',
}
